jQuery( document ).ready(function( $ ) {



    jQuery( '.toggle' ).click(function() {
        jQuery(this).toggleClass('toggle-open');
        jQuery('.navMain__standard').find('.navMain-inner').slideToggle();
  });



});


